import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import A11yHelpers from "../../util/A11yHelpers";
import { meetingTeamPath, meetingTypePath, } from "../../src/View/Pages/MeetingRequest/MeetingRequestRoutes";
export default class MeetingTopic extends Component {
    // @ts-expect-error - TS7006 - Parameter 'props' implicitly has an 'any' type.
    constructor(props) {
        super(props);
        this.renderTopic = this.renderTopic.bind(this);
        this.onCommentChange = this.onCommentChange.bind(this);
        // @ts-expect-error - TS2339 - Property 'virtualizedApp' does not exist on type 'MeetingTopic'.
        this.virtualizedApp = props.virtualizedApp;
    }
    // @ts-expect-error - TS7006 - Parameter 'topic' implicitly has an 'any' type.
    selectMeetingTopic(topic) {
        this.props.selectMeetingTopic(topic);
    }
    // @ts-expect-error - TS7006 - Parameter 'topic' implicitly has an 'any' type.
    renderTopic(topic) {
        return (_jsx("div", { className: "col-md-4 col-sm-6 my-1", children: _jsxs("div", Object.assign({ className: "btn btn-lg " +
                    (topic.isSelected ? "btn-success" : "btn-outline-dark"), tabIndex: 0, role: "button", style: { width: "100%" } }, A11yHelpers.onClickOrEnterOrSpace(() => this.selectMeetingTopic(topic)), { children: [topic.isSelected ? (_jsx("span", { className: "fa fa-check mr-1", "aria-hidden": "true" })) : (""), topic.title] })) }, topic.id));
    }
    // @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type.
    onCommentChange(event) {
        this.props.onCommentChange(event.target.value);
    }
    renderNextButton() {
        const topicSelected = this.props.topics.some((topic) => topic.isSelected);
        const disabledButton = (
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'boolean | undefined'.
        _jsxs("button", { className: "btn btn-primary btn-lg", disabled: "true", children: ["Next ", _jsx("span", { className: "fa fa-chevron-right", "aria-hidden": "true" })] }));
        /**
         * Making sure the user cannot click "Next" if the location is not selected
         * */
        if (topicSelected && this.props.selectedLocation) {
            if (!this.props.hasPeopleAtLocation) {
                return disabledButton;
            }
            if (this.props.hasMeetingWith) {
                return (_jsxs(Link, { to: {
                        pathname: meetingTypePath({}),
                        search: this.props.pageParams,
                    }, className: "btn btn-primary btn-lg", children: ["Next ", _jsx("span", { className: "fa fa-chevron-right", "aria-hidden": "true" })] }));
            }
            // If this is from a campaign and we don't have someone to meet with, disable the next button.
            if (this.props.hasToPickSomeoneToMeetWith) {
                return disabledButton;
            }
            return (_jsxs(Link, { to: {
                    pathname: meetingTeamPath({}),
                    search: this.props.pageParams,
                }, className: "btn btn-primary btn-lg", children: ["Next ", _jsx("span", { className: "fa fa-chevron-right", "aria-hidden": "true" })] }));
        }
        return disabledButton;
    }
    renderTopicSelections() {
        if (!this.props.topics || !this.props.topics.length) {
            if (this.props.hasMeetingWith) {
                return (_jsxs("div", { className: "alert alert-info", children: [_jsx("span", { className: "fa fa-info-circle" }), " This person does not offer any services at this location."] }));
            }
            return "";
        }
        return (_jsxs("div", { className: "mb-4", children: [_jsx("h3", { children: _jsxs("span", { children: ["What would", " ", this.props.isThirdPartyScheduler ? "the student" : "you", " like to discuss?"] }) }), _jsx("div", { className: "row", children: this.props.topics.map(this.renderTopic) })] }));
    }
    render() {
        return (_jsxs("div", { children: [this.props.isLoading ? (_jsx("span", { className: "fa fa-spin fa-circle-o-notch" })) : (""), !this.props.isLoading && this.renderTopicSelections(), _jsx("div", { className: "mb-4", children: _jsxs("div", { children: [_jsx("h3", { children: _jsx("label", { htmlFor: "comment", children: this.props.isThirdPartyScheduler
                                        ? "Other Notes"
                                        : "What is on your mind?" }) }), _jsx("textarea", { id: "comment", className: "form-control", rows: 3, onChange: this.onCommentChange, value: this.props.comment })] }) }), _jsxs("div", { className: "mb-3 d-flex justify-content-between", children: [_jsx("div", {}), this.renderNextButton()] })] }));
    }
}
